import {router} from "@inertiajs/vue3";

export const onClickHashLink = (ev) => {
    const link = ev.target.tagName === 'A' ? ev.target : ev.target.closest('a');

    if (!link) {
        return true;
    }

    ev.preventDefault();
    const path = window.location.protocol + '//' + window.location.host + window.location.pathname;
    const target = document.getElementById(link.href.substring((path + '#').length));

    if (target) {
        history.replaceState(undefined, undefined, "#" + target.id);
        target.scrollIntoView({
            behavior: 'smooth'
        });
    } else {
        router.visit(link.href);
    }
}

export const isTouchDevice = () => {
    return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}
